import axios from 'axios'
import store from '@/store'
import iview from 'view-design'
import { getToken } from '@/libs/util'
// import { Spin } from 'iview'
const addErrorLog = errorInfo => {
  if (!errorInfo) return
  const { statusText, status, data } = errorInfo
  const responseURL = errorInfo.request && errorInfo.request.responseURL
  let apiMsg = ''
  if (data && typeof data.message === 'string' && data.message.trim()) { apiMsg = data.message.trim() } else if (data && typeof data.title === 'string' && data.title.trim()) { apiMsg = data.title.trim() }
  const desc = apiMsg || statusText || 'Request failed'
  iview.Notice.error({
    title: 'Error:' + (status || ''),
    desc,
  })
}

class HttpRequest {
  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }

  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        //
        Authorization: getToken(),
      },
    }
    return config
  }

  destroy(url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }

  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      config => {
        // 添加全局的loading...
        if (!Object.keys(this.queue).length) {
          // Spin.show() // 不建议开启，因为界面不友好
        }
        this.queue[url] = true
        return config
      },
      error => {
        return Promise.reject(error)
      },
    )
    // 响应拦截
    instance.interceptors.response.use(
      res => {
        this.destroy(url)
        const { data, status } = res
        if (data.code >= 400) {
          // const { statuext, status, request: { responseURL } } = errorInfo
          const statusText = data.message
          const status = data.code
          const responseURL = ''
          const err = { statusText, status, request: { responseURL } }
          addErrorLog(err)
        }
        return { data, status }
      },
      error => {
        this.destroy(url)
        addErrorLog(error.response)
        return Promise.reject(error)
      },
    )
  }

  request(options) {
    const instance = axios.create()
    const defaults = this.getInsideConfig()
    // 浅合并会整段替换 headers，导致自定义 Content-Type 时丢失 Authorization（如 Submit 发票 multipart）
    const headers = {
      ...defaults.headers,
      ...(options.headers || {}),
    }
    if (options.data instanceof FormData) {
      // 手写 multipart/form-data 会缺少 boundary；交给运行时自动带 boundary
      delete headers['Content-Type']
    }
    options = Object.assign({}, defaults, options, { headers })
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest
